module.exports = __webpack_public_path__ + "img/cuminmouth.becda722.png";